import React, { useMemo, useState } from 'react';
import { connect, getLocale, useIntl } from 'umi';
import { Bubble, Select, ConfigProvider, Icon } from 'tea-component';
import DeleteSetting from './DeleteSetting';
import SvgIcon from '@/pages/home/components/SvgIcon';
import en_US from 'tea-component/es/i18n/locale/en_US';
import zh_CN from 'tea-component/es/i18n/locale/zh_CN';

import '@/pages/dashboard/assets/scss/components/filterSelect.scss';

const FilterSelect = (props: any) => {
  const {
    gameCode,
    isOutScheme,
    selectorSchemeList,
    getOutSelectorSchemeList,
    selectedValue,
    setSelectedValue,
    filterSchemeChange,
    setEditFilter,
    setFilterModalInfo,
  } = props;
  const [settingShow, setSettingShow] = useState(false);
  const [deletedFilter, setDeletedFilter] = useState({});
  const { formatMessage } = useIntl();

  const renderSchemeListData = useMemo(() => {
    return (
      selectorSchemeList?.map((item: any) => {
        return {
          id: item?.id,
          value: item?.filter_name,
          list: item?.filter_cond,
          text: (
            <Bubble placement="right" dark content={item?.filter_name}>
              <div className="select-filter-tab">
                <span className="select-filter-tab-text">
                  {item?.filter_name || ''}
                </span>
                <div className='select-filter-tab-icon-list'>
                  <i
                    className="select-filter-tab-icon"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      e.nativeEvent.stopImmediatePropagation();
                      setEditFilter(item)
                      setFilterModalInfo({
                        filterModalType: 'edit',
                        filterModalVisible: true,
                      })
                    }}
                  >
                    <Icon type={'pencil'} />
                  </i>
                  <Bubble
                    dark
                    content={formatMessage({ id: 'filter_save_delete' })}
                  >
                    <i
                      className="select-filter-tab-icon"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        e.nativeEvent.stopImmediatePropagation();
                        setDeletedFilter(item);
                        setSettingShow(true);
                      }}
                    >
                      <SvgIcon type="clear-icon" />
                    </i>
                  </Bubble>
                </div>
              </div>
            </Bubble>
          ),
          context: item?.filter_name || '',
        };
      }) || []
    );
  }, [selectorSchemeList, getLocale()]);

  return (
    <span id="select-save-filter">
      <ConfigProvider locale={getLocale() === 'en-US' ? en_US : zh_CN}>
        <Select
          className={`select-filter `}
          appearance="button"
          searchPlaceholder={formatMessage({
            id: 'filter_save_search_placeholder',
          })}
          boxClassName={`select-filter-box dbd-select-filter-box ${renderSchemeListData?.length === 0 ? 'dbd-select-filter-no-data' : ''}`}
          searchable={renderSchemeListData.length > 0 ? true : false}
          listWidth={renderSchemeListData.length > 0 ? 243 : null}
          listHeight={220}
          matchButtonWidth={renderSchemeListData.length > 0 ? false : true}
          options={renderSchemeListData}
          value={selectedValue?.filter_name}
          onChange={(value: any, context: any) => {
            // 当前需求，名称不能重复，所以用value直接获取选中项，如果后面名称可以重复则用id判断（context里拿）
            const selectObj = selectorSchemeList?.filter(
              (item: any) => item?.filter_name === value,
            )?.[0];
            filterSchemeChange(selectObj);
          }}
          footer={
            <div className="dbd-searchbox-label">
              <Bubble
                dark
                content={renderSchemeListData?.length === 0 ? formatMessage({ id: 'filter_save_no_data' }) : formatMessage({ id: 'filter_save_up_to_10' })}
                placement="top-start"
              >
                {renderSchemeListData?.length === 0 ? formatMessage({ id: 'filter_save_no_data' }) : formatMessage({ id: 'filter_save_up_to_10' })}
              </Bubble>
            </div>
          }
          button={
            <div className="select-filter-flex" id="filter-scheme">
              <SvgIcon type="funnel" className="select-filter-icon" />
              {!selectedValue?.filter_name ? (
                <span className="select-filter-text">
                  {formatMessage({ id: 'filter_save_my_filter' })}
                </span>
              ) : (
                <span className="action-text">
                  {
                    renderSchemeListData?.filter((e) => {
                      return e.value === selectedValue?.filter_name;
                    })?.[0]?.context
                  }
                </span>
              )}
            </div>
          }
        />
      </ConfigProvider>
      <DeleteSetting
        visible={settingShow}
        isOutScheme={isOutScheme}
        selectorSchemeList={selectorSchemeList}
        getOutSelectorSchemeList={getOutSelectorSchemeList}
        deletedFilter={deletedFilter}
        selectedValue={selectedValue}
        setSelectedValue={setSelectedValue}
        gameCode={gameCode}
        close={() => {
          setSettingShow(false);
        }}
      />
    </span>
  );
};

export default connect((state: any) => {
  const {
    loading,
    dashboard,
    dashboardSetting: { gameConfig, latestDate, selector, selectorSchemeList },
  } = state;
  return {
    gameConfig,
    selector,
    gameCode: dashboard?.currentGame?.game_code || '',
    // selectorSchemeList,
    selectorSchemeLoading:
      loading.effects['dashboardSetting/selectorSchemeList'],
  };
})(FilterSelect);
